import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps, runtimeCss as _runtimeCss } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("shimmer-slot__defaultslotcss-0wvh6a", {
  position: "relative",
  width: "fit-content"
});
const _staticStyles2 = _cssRef("shimmer-slot__defaultoverlaycss-0ifqt6", {
  position: "absolute",
  inset: 0,
  pointerEvents: "none"
});
const _staticStyles3 = _cssRef("shimmer-slot__defaultreservecss-0h2jry", {
  opacity: 0
});
const _staticStyles4 = _cssRef("shimmer-slot__defaultbarcss-0z0bci", {
  width: "100%",
  height: "100%"
});
import React from 'react';
import type { SerializedStyles } from "@terraindigital/static-styles-react";
import { shimmerHeroThemeAware } from './shimmer.styles';
export type ShimmerSlotProps = {
  reserve: React.ReactNode;
  layoutCss?: SerializedStyles | SerializedStyles[];
  barCss?: SerializedStyles;
  shimmerCss?: SerializedStyles;
  reserveCss?: SerializedStyles;
  slotCss?: SerializedStyles;
  overlayCss?: SerializedStyles;
  'aria-hidden'?: boolean;
};
const defaultSlotCss = _staticStyles;
const defaultOverlayCss = _staticStyles2;
const defaultReserveCss = _staticStyles3;
const defaultBarCss = _staticStyles4;
export const ShimmerSlot = ({
  reserve,
  layoutCss,
  barCss = defaultBarCss,
  shimmerCss = shimmerHeroThemeAware,
  reserveCss = defaultReserveCss,
  slotCss = defaultSlotCss,
  overlayCss = defaultOverlayCss,
  'aria-hidden': ariaHidden = true
}: ShimmerSlotProps): JSX.Element => <div {..._mergeProps({
  css: [slotCss, layoutCss]
})}>
        {reserveCss ? <div {..._mergeProps({
    css: _runtimeCss(reserveCss)
  })}>{reserve}</div> : reserve}
        <div {..._mergeProps({
    css: _runtimeCss(overlayCss),
    "aria-hidden": ariaHidden
  })}>
            <div {..._mergeProps({
      css: [shimmerCss, barCss]
    })} />
        </div>
    </div>;